import pop1 from '../assets/images/pop11.jpg'

const ContactSection = () => {
  return (
    <section className="contact-section d-flex h-100">
      <div className="container">
        <div className="row h-100">
          <div className="col-lg-6">
            <img 
              src={pop1} 
              alt="Restaurant Dish" 
              className="img-fluid w-100 h-100"
              style={{ objectFit: 'cover' }}
            />
          </div>
          <div className="col-lg-6 d-flex flex-column p-5">
            <h2 className="title text-center mb-4">SEE YOU SOON</h2>

            {/* Grouped Location Info */}
            <div className="mb-4">
              <strong className="d-block mb-1">Cordova Location</strong>
              <p className="mb-1 text-black">
                1250 N Germantown Pkwy #105, Cordova, TN
              </p>
              <p className="mb-0 text-black">
                Phone: <a href="tel:+19017078886" className="text-black text-decoration-none">(901)-707-8886</a>
              </p>
            </div>

            <div className="mb-4">
              <strong className="d-block mb-1">Overton Square Location</strong>
              <p className="mb-1 text-black">
                2110 Madison Ave, Memphis, TN 38104
              </p>
              <p className="mb-0 text-black">
                Phone: <a href="tel:+19012076680" className="text-black text-decoration-none">(901)-207-6680</a>
              </p>
            </div>

            <div className="mb-4">
              <strong className="d-block mb-1">Downtown Memphis Location</strong>
              <p className="mb-1 text-black">
                149 Madison Ave, Memphis, TN 38103
              </p>
              <p className="mb-0 text-black">
                Phone: <a href="tel:+19016280086" className="text-black text-decoration-none">(901)-628-0086</a>
              </p>
            </div>

            <div className="mb-4">
              <strong className="d-block mb-1">Poplar Ave Location</strong>
              <p className="mb-1 text-black">
                5167 Poplar Ave, Memphis, TN 38117
              </p>
              <p className="mb-0 text-black">
                Phone: <a href="tel:+19017233188" className="text-black text-decoration-none">(901)-723-3188</a>
              </p>
            </div>

            <div className="mb-4">
              <strong className="d-block mb-1">Little Petals 3</strong>
              <p className="mb-1 text-black">
                890 W Poplar Ave, Memphis, TN 38117
              </p>
              <p className="mb-0 text-black fst-italic text-secondary">Coming in 1 month</p>
            </div>

            <div className="mb-4">
              <strong className="d-block mb-1">Little Petals 4</strong>
              <p className="mb-1 text-black">
                551 S Highland St, Memphis, TN 38111
              </p>
              <p className="mb-0 text-black fst-italic text-secondary">Coming in 2 months</p>
            </div>

            {/* Email */}
            <div className="mb-4">
              <strong className="d-block mb-1">Email Address</strong>
              <p className="mb-0 text-black">petalsofapeony65@gmail.com</p>
            </div>

            {/* Mission Statement */}
            <p className="mt-4 text-center text-orange">
              WE TRY TO MAKE OUR RESTAURANT AS AUTHENTIC AS POSSIBLE, SO OUR CUSTOMERS WILL HAVE THE SAME EXPERIENCE LIKE EATING IN THE FINEST SICHUAN RESTAURANT IN CHINA WITHOUT STEPPING ON A PLANE.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
